import { render, staticRenderFns } from "./Dykclb.vue?vue&type=template&id=94d474ae&scoped=true"
import script from "./Dykclb.vue?vue&type=script&lang=js"
export * from "./Dykclb.vue?vue&type=script&lang=js"
import style0 from "./Dykclb.vue?vue&type=style&index=0&id=94d474ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d474ae",
  null
  
)

export default component.exports